import Theme from '../models/theme';

export const theme: Theme = {
  primary: '#6BCBF1',
  secondary: '#001B40',
  lightText: '#fff',
  darkText: '#4B4B4B',
  grayText: '#5B717C',
  darkGrayText: '#A9AAAA',
  yellowText: '#FFC10E',
  neutral: '#9BB9FF',
  background: '#6B37FE',
  switchTrack: '#6BCBF1',
  switchEnabled: '#5B717C40',
  switchDisabled: '#00000000',
  shadowColor: 'rgba(72, 78, 255, 0.58)',
  cardShadow: 'rgba(229, 234, 242, 0.25)',
  white: '#fff',
  detailsBG: '#EFEFEF',
  inputBorder: '#96a8ca',
  inputPlaceholder: '#00377b',
  inputLabel: '#00234D',
  lightBackground: '#FAFAFA',
  grayBorder: '#E5EAF2',
  canceled: '#EC5968',
  success: '#0CB929',
  pending: '#A9AAAA',
  messageSendedBackground: 'rgba(128, 128, 128, 0.1);',
  messageReceivedBackground: '#EFEFEF',
  chatSeparator: 'rgba(225, 225, 225, 0.8)',
  containerBackground: '#FAFAFA',
  alert: '#ff0037',
};
